.submittals-label {
  color: #00bcd4;
  font-weight: bold;
  letter-spacing: 2px;
  margin-right: 16px;
}

.submittals-banner {
  background: #b2ebf2;
  color: #006064;
  padding: 12px 20px;
  border-radius: 6px;
  margin: 16px 0 24px 0;
  font-size: 1.1em;
}

.table-container {
  height: 100%;
  overflow: auto;
  position: relative;
}

.submittal-detail-card {
  background: #e0f7fa;
  border-top: 6px solid #00bcd4;
  margin-top: 16px;
}

.approved-status {
  color: #388e3c;
  font-weight: bold;
}
.rejected-status {
  color: #d32f2f;
  font-weight: bold;
}

/* ============================== detail page layout Styles ============================== */

/**
https://ionicframework.com/docs/layout/css-utilities
utility classes that should work from Ionic but do nothing on our project
*/
.ion-display-flex {
  display: flex;
}

.full-height {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.vertical-scroll {
  overflow-y: auto;
  height: 100%;
}

.flex-grow {
  flex-grow: 1;
  overflow-y: auto;
}

@media (min-width: 576px) {
  .cc-padding-horizontal-sm-up {
    padding: 0 16px;
  }
}

.description-container {
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
}

.description {
  flex: 1;
}

.mobile-expanded-content {
  margin-top: 16px;
}

.description-container {
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
}

.description {
  flex: 1;
}

/* ============================== Timeline Styles ============================== */

.timeline-container {
  padding: 0 40px 0 40px !important;
}

.timeline-bar {
  position: relative;
  min-height: 80px;
  font-size: 0.8em;
}

.timeline-bar .bar {
  position: absolute;
  top: 17px; /* half of the height of the timeline-state img */
  width: 100%;
  height: 2px;
}

.timeline-bar .bar.complete {
  background-color: #388e3c;
}
.timeline-bar .bar.overdue {
  background-color: red;
}
.timeline-bar .bar.current {
  background-color: var(--ion-color-primary, gold);
}
.timeline-bar .bar.future {
  background-color: grey;
}

.timeline-state .circle.complete {
  border-color: #388e3c;
}
.timeline-state .circle.current {
  border-color: var(--ion-color-primary, gold);
}
.timeline-state .circle.overdue {
  border-color: red;
}
.timeline-state .circle.future {
  border-color: grey;
}

.timeline-state {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  transform: translateX(-50%);
}

.timeline-state .circle {
  width: 34px;
  height: 34px;
  border-width: 2px;
  border-style: solid;
  border-radius: 50%;
  background-size: cover;
  background-color: grey;
}

.timeline-state .circle-stack {
  position: relative;
  width: 36px;
  height: 36px;
}

/** always the top/last circle */

.timeline-state ion-icon.complete {
  position: absolute;
  top: 0;
  right: -4px;
  color: #388e3c;
  font-size: 18px;
}

.timeline-state img {
  width: 34px;
  height: 34px;
}

.timeline-state .label {
  text-align: center;
  white-space: nowrap;
}

.timeline-marker {
  position: absolute;
  top: -16px; /* need to figure this out */
  transform: translateX(-50%); /* center the marker on xpos */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
}

.rounded-bg {
  background: grey;
  padding: 0px 4px;
  border-radius: 8px;
  font-size: 0.8em;
  color: black;
}

.vertical-bar {
  width: 2px;
  height: 20px;
  background: grey;
}

/* ============================== Revision Styles ============================== */

/* Revision List Styles */
.revision-list {
  height: fit-content;
  max-height: 400px;
}

.revision-list-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 300px;
  overflow-y: auto;
}

.revision-item {
  display: flex;
  flex-direction: column;
  padding: 12px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.revision-item:hover {
  border-color: #00bcd4;
}

.revision-item.selected {
  border-color: #00bcd4;
}

.revision-number {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 4px;
}

.revision-number__content {
  flex: 1;
}

.revision-status {
  font-size: 0.9em;
  color: #666;
  margin-bottom: 2px;
}

.revision-date {
  font-size: 0.8em;
  color: #999;
}

.accepted-answer {
  float: inline-end;
  color: var(--color-success-1, green);
}

.accepted-answer ion-icon {
  color: var(--color-success-1, green);
}

.drop-zone {
  border: 2px dashed grey;
  color: grey;
  text-align: center;
  transition: border 0.2s ease;
}

.drag-over {
  border: 2px dashed var(--ion-color-primary, #3dc2ff);
  color: var(--ion-color-primary, 'yellow');
  text-align: center;
  background-color: rgba(255, 255, 255, 0.1);
}

.submital-detail-filter-name {
  color: var(--background-color-step-400);
}

/* ============================== Submittal Edit Modal Styles ============================== */

/* the submittal-edit-modal gets rendered in the sidebar of the specification viewer 
so that means the max height is less to accommodate the concourse-header above.
*/
@media (min-width: 768px) {
  .edit-modal-content {
    --background: var(--color-background-3, grey);
    max-height: calc(100vh - 57px - 57px - 57px); /* here we have 2 headers and a footer */
    overflow-y: auto;
    flex: 1; /* KEY: take remaining space */
  }
}

@media (max-width: 768px) {
  .edit-modal-content {
    --background: var(--color-background-3, grey);
    max-height: calc(100vh - 57px - 57px); /* here we have 1 header and a footer */
    overflow-y: auto;
    flex: 1; /* KEY: take remaining space */
  }
}

.edit-modal-content ion-grid ion-col {
  padding: 2px;
}